import {
    EnvironmentFilled,
    MoreOutlined,
    QrcodeOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

export const StyledMBAboutPointButton = styled(Button)`
    height: 32px;
    font-size: 16px;
`;

export const StyledMBGeoPin = styled(EnvironmentFilled)`
    color: #1677ff;
    font-size: 26px;
    height: 26px;
`;

export const StyledMBCopyButton = styled(Button)`
    border: none;
    box-shadow: none;
    color: ${(props) => props.theme.primaryTypographyColor};
    span {
        font-size: 26px !important;
    }
`;

export const StyledMBPointMenuController = styled(MoreOutlined)`
    cursor: pointer;
    color: ${(props) => props.theme.secondaryTypographyColor};
    font-size: 24px;
`;

export const StyledMBQRIcon = styled(QrcodeOutlined)`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 26px;
    cursor: pointer;
`;
